export const UserActionTypes = {
    SET_USERNAME: 'SET_USERNAME',
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_USER_TOKEN: 'SET_USER_TOKEN',
    RESET_USER_DATA: 'RESET_USER_DATA'
}